import { ReactNode } from "react";
import { LoadingContext } from "./loadingContextDefinition";

export function LoadingProvider({
  children,
  isLoading,
}: {
  children: ReactNode;
  isLoading: boolean;
}) {
  return (
    <LoadingContext.Provider value={{ isLoading }}>
      {children}
    </LoadingContext.Provider>
  );
}
